<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">AP-Check</div>
    </div>
    <div class="col-md-12 well-content">
        @if (!loading) {
            <div class="panel panel-default">
                <div class="panel-heading">Pre-Print Information</div>
                <div class="panel-body">
                    <form class="form-horizontal">
                        @if (APInfo.UsesBankAccount) {
                            <div class="form-group">
                                <label
                                    for="bankAccount"
                                    class="col-md-3 control-label text-right has-tooltip"
                                    [nz-tooltip]="bankTip"
                                    >Bank Account Number:</label
                                >
                                <div class="col-md-3">
                                    <input
                                        nz-input
                                        class="form-control"
                                        type="number"
                                        maxlength="10"
                                        name="bankAccount"
                                        id="bankAccount"
                                        [(ngModel)]="bankAccount"
                                        (ngModelChange)="onFieldChange()"
                                        [readonly]="this.printing" />
                                </div>
                            </div>
                        }
                        <div class="form-group">
                            <label
                                for="firstCheck"
                                class="col-md-3 control-label text-right has-tooltip"
                                [nz-tooltip]="firstCheckTip">
                                First Check Number:
                            </label>
                            <div class="col-md-3">
                                <input
                                    nz-input
                                    class="form-control"
                                    type="text"
                                    min="1"
                                    maxlength="10"
                                    max="9999999999"
                                    name="firstCheck"
                                    id="firstCheck"
                                    [(ngModel)]="firstCheck"
                                    (ngModelChange)="onFieldChange()"
                                    [readonly]="this.printing" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label
                                for="lastCheck"
                                class="col-md-3 control-label text-right has-tooltip"
                                [nz-tooltip]="lastCheckTip">
                                Last Check Number:
                            </label>
                            <div class="col-md-3">
                                <input
                                    nz-input
                                    class="form-control"
                                    type="text"
                                    min="1"
                                    maxlength="10"
                                    max="9999999999"
                                    name="lastCheck"
                                    id="lastCheck"
                                    [(ngModel)]="lastCheck"
                                    (ngModelChange)="onFieldChange()"
                                    [readonly]="this.printing" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        }
        @if (!loading) {
            <div class="panel panel-default">
                <div class="panel-heading">Signatures</div>
                <div class="panel-body">
                    <form class="form-horizontal">
                        <div class="form-group">
                            <label
                                for=""
                                class="col-md-3 control-label text-right has-tooltip"
                                [nz-tooltip]="primarySigTip">
                                Primary Signature:
                            </label>
                            @if (APInfo.UserIsAdmin) {
                                <div class="col-md-3" style="font-weight: bold">
                                    <button
                                        class="btn btn-default"
                                        (click)="showSignatureModal(sigTmpl, 1)"
                                        [disabled]="this.printing">
                                        <i class="fa-regular fa-edit" nz-tooltip="Edit Primary Signature"></i>
                                    </button>
                                    @if (primarySignature) {
                                        {{ primarySignature.SignatureName }}
                                    } @else {
                                        &lt;none&gt; <span style="color: red">Required</span>
                                    }
                                </div>
                            } @else {
                                <div class="col-md-3" style="font-weight: bold">
                                    <p></p>
                                    {{ primarySignature ? primarySignature.SignatureName : "\<none\>" }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label
                                for=""
                                class="col-md-3 control-label text-right has-tooltip"
                                [nz-tooltip]="secondarySigTip">
                                Secondary Signature:
                            </label>
                            @if (APInfo.UserIsAdmin) {
                                <div class="col-md-3" style="font-weight: bold">
                                    <button
                                        class="btn btn-default"
                                        (click)="showSignatureModal(sigTmpl, 2)"
                                        [disabled]="this.printing">
                                        <i class="fa-regular fa-edit" nz-tooltip="Edit Secondary Signature"></i>
                                    </button>
                                    @if (secondarySignature) {
                                        {{ secondarySignature.SignatureName }}
                                    } @else {
                                        &lt;none&gt; <span style="color: red">Required</span>
                                    }
                                </div>
                            } @else {
                                <div class="col-md-3" style="font-weight: bold">
                                    <p></p>
                                    {{ secondarySignature ? secondarySignature.SignatureName : "\<none\>" }}
                                </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
        }
        @if (!loading) {
            <div>
                <button class="btn btn-default" (click)="showPrintPreview()">Display Sample Print Preview</button>
                <button
                    [disabled]="buttonsDisabled || printing"
                    [nz-tooltip]="printing ? printingMessage : buttonsDisabled ? disabledMessage : ''"
                    class="btn btn-default"
                    (click)="printOrValidate(true)">
                    Validate Check Range
                </button>
                <button
                    [disabled]="buttonsDisabled || printing"
                    [nz-tooltip]="printing ? printingMessage : buttonsDisabled ? disabledMessage : ''"
                    class="btn btn-default"
                    (click)="printOrValidate()">
                    Print Checks
                </button>
                <!--
                <button
                  *ngIf="printing"
                  nz-tooltip="Stop checking the status."
                  class="btn btn-default"
                  (click)="stopPolling(true)">
                  Stop
                </button>
                -->
            </div>
        }
        @if (!loading && (printing || printStatus)) {
            <textarea
                nz-input
                rows="2"
                cols="20"
                readonly="readonly"
                [value]="printStatus"
                disabled
                style="cursor: text; margin-top: 15px"
                [style.color]="printError ? 'red' : 'black'">
            </textarea>
        }
        @if (!loading && doneFile) {
            <div style="margin-top: 5px">
                <a [href]="doneFile" target="_blank">Download File</a>
            </div>
        }
        <div style="margin-top: 15px">
            <a title="View Logs" target="_blank" [routerLink]="['/ap/logs']">View Logs</a>
        </div>
    </div>
</div>
<!-- signature modal -->
<ng-template #sigTmpl>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title">Modify/View {{ currentSignatureType }} Signature</h4>
    </div>
    <div class="modal-body">
        <form class="form-horizontal" style="padding: 8px">
            <div class="form-group">
                <label for="sigName" class="control-label" style="text-align: left">
                    {{ currentSignatureType }} Signature Name:
                </label>
                <div>
                    <input
                        nz-input
                        class="form-control"
                        type="text"
                        maxlength="200"
                        name="sigName"
                        id="sigName"
                        [(ngModel)]="currentSignature.SignatureName"
                        (ngModelChange)="onSignatureNameChange($event)" />
                </div>
                @if (signatureError) {
                    <div>
                        <span style="color: red">{{ signatureError }}</span>
                    </div>
                }
            </div>
            <div class="form-group">
                <label for="sigPic" class="control-label" style="text-align: left">
                    Please select a PNG signature. (750px x 93px &#64; 300 PPI. Transparency recommended.)
                </label>
            </div>
            <div class="form-group">
                <nz-upload
                    name="upload"
                    id="upload"
                    nzListType="text"
                    [(nzFileList)]="fileList"
                    [nzShowButton]="fileList.length < 1"
                    (nzChange)="onUploadChange($event)">
                    <button class="btn btn-default">
                        @if (fileList.length === 0) {
                            <nz-icon nzType="upload" />
                        }
                        Click here to upload png
                    </button>
                </nz-upload>
            </div>
            <div class="form-group">
                @if (signatureUploadError) {
                    <div>
                        <span style="color: red">{{ signatureUploadError }}</span>
                    </div>
                }
            </div>
            <div class="form-group">
                <button
                    #saveBtn
                    type="button"
                    [disabled]="!(signatureHasName && signatureHasImage)"
                    class="btn btn-primary"
                    [safeTooltip]="!(signatureHasName && signatureHasImage) ? 'name and image are required' : ''"
                    safeTooltipPlacement="top"
                    (click)="saveSignature()">
                    Save Changes
                </button>
                <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cancel</button>
            </div>
            @if (currentSignature.DisplayImage) {
                <div class="form-group">
                    <p>Preview:</p>
                    <img
                        [src]="currentSignatureDisplayImage"
                        style="border: 1px dotted; width: 100%; height: 100%; object-fit: scale-down"
                        alt="{{ currentSignatureType }} signature" />
                </div>
            }
        </form>
    </div>
</ng-template>
